var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.833 13.3333V15.8333C15.833 16.0543 15.7452 16.2663 15.5889 16.4226C15.4327 16.5789 15.2207 16.6667 14.9997 16.6667H4.99967C4.55765 16.6667 4.13372 16.4911 3.82116 16.1785C3.5086 15.866 3.33301 15.442 3.33301 15V5M14.1663 6.66667V4.16667C14.1663 3.94566 14.0785 3.73369 13.9223 3.57741C13.766 3.42113 13.554 3.33334 13.333 3.33334H4.99967C4.55765 3.33334 4.13372 3.50893 3.82116 3.82149C3.5086 4.13405 3.33301 4.55798 3.33301 5C3.33301 5.44203 3.5086 5.86595 3.82116 6.17851C4.13372 6.49107 4.55765 6.66667 4.99967 6.66667H14.9997C15.2207 6.66667 15.4327 6.75447 15.5889 6.91075C15.7452 7.06703 15.833 7.27899 15.833 7.5V10L14.1663 6.66667Z",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.667 10V13.3333H13.3337C12.8916 13.3333 12.4677 13.1577 12.1551 12.8452C11.8426 12.5326 11.667 12.1087 11.667 11.6667C11.667 11.2246 11.8426 10.8007 12.1551 10.4882C12.4677 10.1756 12.8916 10 13.3337 10H16.667Z",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/Wallet.6706d5d1.svg";
export { ForwardRef as ReactComponent };